import { render, staticRenderFns } from "./TgButton.vue?vue&type=template&id=6b332895"
import script from "./TgButton.vue?vue&type=script&lang=js"
export * from "./TgButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports